<div class="main-div">
<mat-card class="card">
  <mat-card-header>
    <div mat-card-avatar class="header-image"></div>
    <mat-card-title>GP Automazioni</mat-card-title>
    <mat-card-subtitle style="color: whitesmoke;">Chi siamo</mat-card-subtitle>
  </mat-card-header>
  <img mat-card-image src="assets/img/furgoneLat.jpeg" alt="Photo of the GP Automazioni truck">
  <mat-card-content>
    <p>
      La Ditta G.P. Automazioni s.r.l., è stata costituita nel 2022 dalla cooperazione di professionisti del settore, ciascuno con decennali
      d'esperienza nel campo. La ns. società opera nell'ambito impiantistico industriale,
      terziario e civile in diversi campi, tali da poter offrire un servizio completo ai propri partners
    </p>
  </mat-card-content>
  <!--<mat-card-actions>
    <button mat-button>LIKE</button>
    <button mat-button>SHARE</button>
  </mat-card-actions>-->
</mat-card>
</div>
